(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["available-offers"] && !Shopify.designMode) return;
  try {
    (function () {
    function equalizeOfferCardHeights() {
      document.querySelectorAll('.product-offers-carousel').forEach(function (carousel) {
        var cards = carousel.querySelectorAll('.offer-card');
        if (!cards.length) return;

        // Reset heights so we can measure natural height
        cards.forEach(function (c) { c.style.height = ''; });

        // Find the tallest card
        var maxH = 0;
        cards.forEach(function (c) { maxH = Math.max(maxH, c.offsetHeight); });

        // Apply uniform height
        cards.forEach(function (c) { c.style.height = maxH + 'px'; });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', equalizeOfferCardHeights);
    } else {
      equalizeOfferCardHeights();
    }

    // Re-equalize on resize (e.g. font scaling, orientation change)
    window.addEventListener('resize', equalizeOfferCardHeights);
  })();
  } catch(e) { console.error(e); }
})();

})();
